import { FaAward } from "react-icons/fa";
import { TbBooks } from "react-icons/tb";

const data = [
  { id: 1, icon: <FaAward />, title: "Experience", desc: "1 year Working" },
  { id: 2, icon: <TbBooks />, title: "Projects", desc: "5+ Completed" },
];

export default data;
